module.exports = __webpack_public_path__ + "media/AISpace2-vis.06b85f51.mp4";